<template>
  <div
    class="add-to-cart"
    :class="{
      [$class('loading')]: !product,
    }"
  >
    <button
      class="
        add-to-cart__button
        button
        button--primary
      "
      :class="
        {
          [$class('disabled')]: !product?.available,
        }
      "
      type="button"
      @click.prevent="handleAddToCart"
    >
      <span
        v-if="product?.available"
        class="button__label text-other-button-s"
        v-text="addToCartText"
      />
      <span
        v-else
        class="button__label text-other-button-s"
        v-text="$string('product_card.sold_out')"
      />
    </button>
  </div>
</template>

<script>

/**
 * Vue: Add to cart (add-to-cart)
 * @param {Boolean|Object} product - Product object.
 * -----------------------------------------------------------------------------
 * Add to cart.
 *
 */
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AddToCart',

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    openCartDrawer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      error: '',
      state: 'ready',
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
     ...mapGetters({
      getComponentExists: 'components/getExists',
    }),

    /**
     * Compute add to cart text.
     * @returns {String}
     */
    addToCartText() {
      return this.state === 'added'
        ? this.$string('product_card.added_to_cart')
        : this.$string('product_card.add_to_cart')
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      addItem: 'cart/addItem',
      openOverlay: 'overlays/open',
    }),

    /**
     * Handle add to cart submission.
     */
    async handleAddToCart() {
      if (!this.product) {
        this.state = 'empty'
        return
      }

      if (!this.product.available) {
        return
      }

      this.error = ''
      this.state = 'adding'

      const items = [
        {
          id: this.product.variants[0].id,
          quantity: 1,
        },
      ]

      try {
        await this.addItem(items)

        if (
          this.openCartDrawer &&
          cnvs.settings.autoOpenCartDrawer &&
          this.getComponentExists('cart-drawer')
        ) {
          this.openOverlay({
            component: 'cart-drawer',
            ignoreDismissed: true,
            namespace: 'cartDrawer',
          })
        }

        this.state = 'added'

        await new Promise((resolve) => {
          setTimeout(resolve, this.$timing('message'))
        })

        this.state = 'ready'

      } catch (error) {
        this.state = 'error'

        if (error?.description) {
          this.error = error.description
          return
        }

        cnvs.ReportError('Failed to add product to cart', error)
      }
    },
  },
}
</script>

<style lang="scss">
@import './add-to-cart';
</style>
